module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAADKADAAQAAAABAAAADAAAAAATDPpdAAAAzklEQVQoFaWQOw6CQBRFBxo7E1dBaaWVq7BjBfYux5IKlsAuZAPEysqCiBWfjGdg3uSJdprceOf+ZoIx//ystdthGApQgwcoQfpzcxzHE2bX971dAj1nLA5FvzyFMVtwBE9dZPAcCpiFNjlfGDnoErxBi6YSh1oXHEeTUngmhUTetQ7XeYK5h97BS3lzjrVycUPl1tCuopPp0FZTmUOqjNaHK9HcP5lM3WQMQi4BeCvch2+MbD4KCLH7dIQbCcM7kH2FdRMzAgnYgfnNKvAGS2RNRc2rxpIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/img/NotaryDetail/go.png
// module id = PCg1
// module chunks = 1